import { createSlice } from '@reduxjs/toolkit';

const bonusPrizeSlice = createSlice({
  name: 'bonusPrize',
  initialState: {
    bonusSchedules: [],
  },
  reducers: {
    setBonusPrizeData(state, action) {
      state.bonusSchedules = action.payload;
    },
    addBonusSchedule(state, action) {
      const idx = state.bonusSchedules.findIndex(s => s.id === action.payload.id);
      if (idx >= 0) state.bonusSchedules[idx] = action.payload;
      else state.bonusSchedules.push(action.payload);
    },
    removeBonusSchedule(state, action) {
      state.bonusSchedules = state.bonusSchedules.filter(s => s.id !== action.payload);
    },
  },
});

export const { setBonusPrizeData, addBonusSchedule, removeBonusSchedule } = bonusPrizeSlice.actions;
export default bonusPrizeSlice.reducer;
